import React from 'react';
import IafsTable from './IafsTable';

function InvoiceIafsTable({ iafs }) {
  return (
    <IafsTable
      title="Compensi da fatture fornitore"
      iafs={iafs}
      anchorId="iafs-invoice"
    />
  );
}

export default InvoiceIafsTable;
